import React, {useState} from 'react';
import {PictureOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";

const Brand = ({brand, children, className = ''}) => {
    const [imagePath, setImagePath] = useState(() => {
        return brand.logo || brand.logo_path || brand.icon || brand.icon_path
    })
    return (
        <div className={TB.mapClass("pointer-events-auto flex items-center justify-center relative py-3 px-3 w-36 min-w-36 h-28 border border-gray-200 rounded-lg", {
            [className]: true
        })}>
            {/* Checker pattern background */}
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 to-gray-300 opacity-50"/>

            {/*Extra content*/}
            {children}

            <div className="relative overflow-hidden flex items-center justify-center">
                {imagePath ?
                    <img className="h-full max-h-24 w-full max-w-32 object-contain"
                         src={imagePath}
                         alt={brand.name}/> : (
                        <PictureOutlined className="w-full max-w-full"
                                         style={{fontSize: 56}}/>
                    )}
            </div>
        </div>
    )
}
const ProfileBrand = ({brand, className= '',showTooltip = true, isDisabled, tooltipPlacement = 'top', children, ...props}) => {

    let brandClass = className;
    if (isDisabled) {
        brandClass += ' grayscale';
    }
    if (!showTooltip) {
        return (
            <Brand
                key={props.key || undefined}
                brand={brand} className={brandClass}>
                {children}
            </Brand>
        )
    }
    return (
        <Tooltip
            key={props.key || undefined}
            placement={tooltipPlacement}
            title={(
                <div className="flex flex-col gap-1">
                    <p className="text-xs text-white">{brand.name || brand.domain}</p>
                    {brand.name && brand.domain && (
                        <p className="text-xs text-info whitespace-nowrap">
                            {brand.domain}
                        </p>
                    )}
                </div>
            )}
        >
            <div>
                <Brand brand={brand} className={isDisabled ? 'grayscale opacity-60' : ''}>
                    {children}
                </Brand>
            </div>
        </Tooltip>
    )
};

export default ProfileBrand;